import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { menuInterface } from '../../Model/Administracion/menu.Interface';
import { DataApi } from '../../Model/dataApi';

@Injectable({
  providedIn: 'root'
})
export class AdministracionService {

  constructor(private http: HttpClient) { }

  GetMenu(url: string, params: any) {
    return this.http.post<DataApi>(environment.apiUrlS + url, params);
  }

  PostMenu(url: string, params: any) {
    return this.http.post<DataApi>(environment.apiUrlS + url, params);
  }

  DeleteMenu(url: string, params: any) {
    const options = { headers: new HttpHeaders({'Content-Type': 'application/json',}),
      body: params
    };
    return this.http.delete<DataApi>(environment.apiUrlS + url, options);
  }

  PutMenu(url: string, params: any) {
    return this.http.put<DataApi>(environment.apiUrlS + url, params);
  }
}
